define('modules/files/file_model',[
    'backbone',
    'session'
], function (Backbone, session) {
    'use strict';
    var Model = Backbone.Model.extend({
        defaults: {},
        parse: function (response, options) {
            var respond = {},

                sections = new Backbone.Collection();


            delete response.sections;

            _.extend(respond, response);
            _.extend(respond, {sections: sections});

            return respond;
        },
        url: function () {
            return session.get('apiUrl') + 'files/' + this.id;
        }
    });

    return Model;
});

